import { User, Mail, Shield, Building2 } from 'lucide-react';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export function UserProfileCard() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-muted" />
          <div className="space-y-2 flex-1">
            <div className="h-5 w-40 bg-muted rounded" />
            <div className="h-4 w-60 bg-muted rounded" />
          </div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="text-center text-muted-foreground py-4">
        Não foi possível carregar os dados do usuário.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* User Avatar and Name */}
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-[hsl(var(--basic-100))] flex items-center justify-center text-2xl font-bold text-[hsl(var(--basic-600))]">
          {currentUser.full_name?.charAt(0)?.toUpperCase() || currentUser.email?.charAt(0)?.toUpperCase() || 'U'}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold text-foreground truncate">
            {currentUser.full_name || 'Sem nome'}
          </h3>
          <p className="text-sm text-muted-foreground truncate">
            {currentUser.email || 'Email não disponível'}
          </p>
        </div>
      </div>

      {/* User Details Grid */}
      <div className="grid grid-cols-1 gap-4">
        <div className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
          <Mail className="h-5 w-5 text-[hsl(var(--basic-400))]" />
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground">Email</p>
            <p className="text-sm font-medium text-foreground truncate">
              {currentUser.email || 'Não informado'}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
          <User className="h-5 w-5 text-[hsl(var(--basic-400))]" />
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground">Nome Completo</p>
            <p className="text-sm font-medium text-foreground truncate">
              {currentUser.full_name || 'Não informado'}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
          <Shield className="h-5 w-5 text-[hsl(var(--basic-400))]" />
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground">ID do Usuário</p>
            <p className="text-sm font-medium text-foreground font-mono">
              {currentUser.user_id?.slice(0, 8)}...{currentUser.user_id?.slice(-4)}
            </p>
          </div>
        </div>

        {currentUser.company_name && (
          <div className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
            <Building2 className="h-5 w-5 text-[hsl(var(--basic-400))]" />
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground">Empresa</p>
              <p className="text-sm font-medium text-foreground truncate">
                {currentUser.company_name}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
